module.exports = {"sld:ColorMapEntry":[{"color":"#0074ad","label":"< 0.71886","quantity":0.00719},{"color":"#9dc4b5","label":" 0.71886- 0.71886","quantity":0.00719},{"color":"#e6efc3","label":" 0.71886- 0.80642","quantity":0.00806},{"color":"#ffe89e","label":" 0.80642- 1.25937","quantity":0.01259},{"color":"#f5af7f","label":" 1.25937- 2.24148","quantity":0.02241},{"color":"#ed6d32","label":" 2.24148- 15.4077","quantity":0.15408}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/fxfl_raster/rice_MME_1981_2016_lcr_80_return_10.json
// module id = j9UI
// module chunks = 171